export class PcsDocumentAndApprovalStatusCodes {
    public static readonly _2ND_WFA = '2ND_WFA';
    public static readonly _3RD_WFA = '3RD_WFA';
    public static readonly APP = 'APP';
    public static readonly CRT = 'CRT';
    public static readonly DEL = 'DEL';
    public static readonly NEW = 'NEW';
    public static readonly NFA = 'NFA';
    public static readonly REJ = 'REJ';
    public static readonly WFA = 'WFA';

    public static readonly WaitingForApproval: string[] = [
        PcsDocumentAndApprovalStatusCodes.WFA,
        PcsDocumentAndApprovalStatusCodes._2ND_WFA,
        PcsDocumentAndApprovalStatusCodes._3RD_WFA
    ];

    public static readonly PendingApprovalStatuses: string[] = [
        PcsDocumentAndApprovalStatusCodes.CRT,
        PcsDocumentAndApprovalStatusCodes.WFA
    ];
}
